import {
  Dataviz,
  DatavizName,
  getDefaultDataviz,
} from "@radarly/models/dataviz";
import { InfluencerFragment } from "@radarly/models/search";
import { isPinnedAuthorCardDataviz } from "../dataviz";
import { Card, PinnedAuthorCard } from "../model";
import { CardFactory, CardFragmentsFactory } from "./base";
import { ICardFactory } from "./model";

export class PinnedAuthorCardFragmentsFactory extends CardFragmentsFactory {
  static create(authorId?: string) {
    const factory = new PinnedAuthorCardFragmentsFactory();
    return factory.getFragment(authorId);
  }
  private getFragment(authorId: string): [InfluencerFragment] {
    return [{ type: "influencer", authorId }];
  }
}

export class PinnedAuthorCardFactory
  implements ICardFactory<PinnedAuthorCard, Record<string, unknown>>
{
  public static getInstance() {
    return new PinnedAuthorCardFactory();
  }
  public fromCard(
    workspaceId: number,
    projectFocuses: number[],
    card: Card,
    input?: {
      authorId?: string;
      dataviz?: Dataviz;
    }
  ) {
    return CardFactory.getInstance<PinnedAuthorCard>().createCard(
      workspaceId,
      projectFocuses,
      "pinned-author",
      card.title,
      PinnedAuthorCardFragmentsFactory.create(input.authorId),
      this.createDataviz(input?.dataviz || card.dataviz)
    );
  }
  public fromInput(
    workspaceId: number,
    projectFocuses: number[],
    title: string,
    input?: {
      authorId?: string;
      dataviz?: Dataviz["name"];
      fullDataviz?: Dataviz;
    }
  ) {
    return CardFactory.getInstance<PinnedAuthorCard>().createCard(
      workspaceId,
      projectFocuses,
      "pinned-author",
      title,
      PinnedAuthorCardFragmentsFactory.create(input?.authorId),
      this.createDataviz(
        input?.fullDataviz ??
          getDefaultDataviz(input?.dataviz || DatavizName.PinnedAuthor)
      )
    );
  }
  public createDataviz(dataviz: Dataviz) {
    if (isPinnedAuthorCardDataviz(dataviz)) {
      return dataviz;
    } else {
      return getDefaultDataviz(
        DatavizName.PinnedAuthor
      ) as PinnedAuthorCard["dataviz"];
    }
  }
}
